//add all utils scripts here
/**
 * purpose: To calculate the Time left in count down.
 * @param {*} countDown 
 * @returns 
 */
const CalculateTime = (countDown) => {
    // calculate time left
    const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((countDown % (1000 * 60)) / 1000);
    const zeroPad = (num, places) => String(num).padStart(places, '0');
    return [zeroPad(days, 2),zeroPad(hours, 2),zeroPad(minutes, 2),zeroPad(seconds, 2)];
  };

export default CalculateTime;
